import React from 'react';
import IconButton from '@material-ui/core/IconButton';

const moreVertIcon = '/img/icons/menu-options.svg';

const OptionsButton = props => {
  return (
    <IconButton {...props}>
      <img src={moreVertIcon} alt="Menu Opciones" />
    </IconButton>
  );
};

export default OptionsButton;
